import React, { useState } from 'react';
import { Modal } from '../..';
import {
	Divider,
	Typography,
	Grid,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	ListItem,
	ListItemText,
	List
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../MarketingCampaigns.styles';
import { mainColor } from '../../../constants';
import { CampaignType, EXPANDABLE_SECTIONS } from '../../../constants/marketingCampaign';
import _ from 'lodash';
import { CAMPAIGN_ITEMS } from '../../../constants/marketingCampaign';
import { SUITABLE_ORDER_TYPES, ALL_ORDER_TYPES } from '../../../constants/dataConfig';
import { getProductDetailsFromConfig, getOffersFromConfig } from '../../../utils/product';
import { formatDateTime } from '../../../utils/tools';
import { getCreatorLabel } from '../MarketingCampaigns.services';
const StyledAccordion = withStyles({
	root: {
		border: 'none',
		boxShadow: 'none',
		margin: '0 !important',
		padding: '0',
		width: '100%',
		overflow: 'hidden',
		'&:before': { display: 'none' },
		'&$expanded': {
			margin: '0 !important',
			minHeight: 'unset !important'
		},
	},
	expanded: {},
})(Accordion);

const StyledAccordionSummary = withStyles({
	root: {
		minHeight: '45px !important',
		height: '45px',
		padding: '0 12px',
		'&$expanded': { minHeight: '45px !important', height: '45px' },
	},
	content: {
		margin: '0 !important',
		'&$expanded': { margin: '0 !important' },
		alignItems: 'center',
	},
	expandIcon: {
		marginRight: '0px !important',
		transform: 'rotate(0deg)',
		transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
		'&$expanded': {
			transform: 'rotate(180deg)',
		},
		'&:hover': {
			backgroundColor: `rgba(${mainColor.rgb}, 0.5)`
		},
		padding: '7px 7px 7px 7px'
	},
	expanded: {},
})(AccordionSummary);

const ProductDetailsModal = ({
	classes,
	showModal,
	handleClose,
	selectedCampaign,
	menus,
	shops = {},
}) => {
	const { type, config, dateEnd, dateStart, shopIds, marketingCampaignKey, createdBy } = selectedCampaign;
	const { title, description, inputDescription, inputText } = CAMPAIGN_ITEMS.filter(item => type === item.id)[0];

	const modalTitle = marketingCampaignKey
		? `Détails de l'offre ${marketingCampaignKey} (${getCreatorLabel(createdBy, shops)})`
		: `Détails de l'offre ${title?.toLowerCase()}`;
	const withoutRightPart = type === CampaignType.BUY_ONE_GET_ONE_PRODUCT || type === CampaignType.BUY_ONE_GET_ONE_DIFFERENT_PRODUCT;
	const sections = !withoutRightPart ? getProductDetailsFromConfig(menus, config?.products, shopIds[0]) : [];
	const offers = withoutRightPart ? getOffersFromConfig(menus, config?.products, shopIds[0]) : [];

	const getDefaultPanel = () => {
		if (type === CampaignType.PRODUCT_DISCOUNT || type === CampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD) return EXPANDABLE_SECTIONS.DISCOUNT;
		if (withoutRightPart) return EXPANDABLE_SECTIONS.PRODUCTLIST;
		return EXPANDABLE_SECTIONS.DATES;
	};
	const [expandedSection, setExpandedSection] = useState(getDefaultPanel());



	const handleAccordionChange = (panel) => (event, isExpanded) => {
		setExpandedSection(isExpanded ? panel : null);
	};

	const orderTypes = config?.orderTypes ?? selectedCampaign?.orderTypes ?? [];
	const effectiveOrderTypes = orderTypes.length > 0 ? orderTypes : ALL_ORDER_TYPES;

	const AccordionContent = ({ description, value, valueSymbol }) => (
		<AccordionDetails className='py-2 px-1'>
			<Grid container spacing={1} alignItems="center">
				<Grid item xs={10}>
					<Typography variant="body2">{description}</Typography>
				</Grid>
				<Grid item xs={2}>
					<Typography variant="body2">{value} {valueSymbol}</Typography>
				</Grid>
			</Grid>
		</AccordionDetails>
	);

	const ProductListContent = ({ selectedProducts }) => (
		<AccordionDetails className='p-0' style={{ display: 'block', overflow: 'auto', marginRight: '12px' }}>
			<List style={{ height: selectedProducts && _.size(selectedProducts) > 3 && '29vh', overflow: 'auto' }}>
				{_.map(selectedProducts, (offer, index) => (
					<React.Fragment key={index}>
						<ListItem className='px-1'>
							<Grid container spacing={1} alignItems="center">
								<Grid item xs={11}>
									<Typography variant="body2">
										1 {offer.productName} <b>acheté</b> ⇒ 1 {offer.productOfferedName}{' '}
									<b>{type === CampaignType.BUY_ONE_GET_ONE_DIFFERENT_PRODUCT ? 'cadeau offert' : 'offert'}</b>
									</Typography>
								</Grid>
							</Grid>
						</ListItem>
						{_.size(selectedProducts) - 1 !== index && <Divider />}
					</React.Fragment>
				))}
			</List>
		</AccordionDetails>
	);

	const renderInputs = () => {
		if (type === CampaignType.PRODUCT_DISCOUNT || type === CampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD) {
			return (
				<>
					<StyledAccordion
						expanded={expandedSection === EXPANDABLE_SECTIONS.DISCOUNT}
						onChange={handleAccordionChange(EXPANDABLE_SECTIONS.DISCOUNT)}
					>
						<StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
							<ListItem className='p-0'>
								<ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>{inputText}</span>} />
							</ListItem>
						</StyledAccordionSummary>
						<AccordionContent
							description={inputDescription}
							value={config.discount?.value}
							valueSymbol='%'
						/>
					</StyledAccordion>
					<Divider className={classes.dividerStyle} />

					{type === CampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD && (
						<>
							<StyledAccordion
								expanded={expandedSection === EXPANDABLE_SECTIONS.THRESHOLD}
								onChange={handleAccordionChange(EXPANDABLE_SECTIONS.THRESHOLD)}
							>
								<StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
									<ListItem className='p-0'>
										<ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>Panier minimum</span>} />
									</ListItem>
								</StyledAccordionSummary>
								<AccordionContent
									description="Pour activer l'offre le client doit dépenser"
									value={config.threshold}
									valueSymbol='€'
								/>
							</StyledAccordion>
							<Divider className={classes.dividerStyle} />
						</>
					)}
				</>
			);
		} else if (withoutRightPart) {
			return (
				<>
					<StyledAccordion
						expanded={expandedSection === EXPANDABLE_SECTIONS.PRODUCTLIST}
						onChange={handleAccordionChange(EXPANDABLE_SECTIONS.PRODUCTLIST)}
					>
						<StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
							<ListItem className='p-0'>
								<ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>Liste des offres</span>} />
							</ListItem>
						</StyledAccordionSummary>
						<ProductListContent selectedProducts={offers} />
					</StyledAccordion>
					<Divider className={classes.dividerStyle} />
				</>
			);
		}
		return null;
	};

	return (
		<Modal
			color="secondary"
			title={modalTitle}
			header
			fixed
			size="xl"
			btnTxt="Retour"
			modalBodyClass={`py-0 ${withoutRightPart && classes.modalHight}`}
			isOpen={showModal}
			onClick={handleClose}
			handleClose={handleClose}
			{...(!withoutRightPart && { width: '950px' })}

		>
			<p className='pt-2'>{description}</p>
			<div className={!withoutRightPart && classes.responsiveContainer}>
				<div className={!withoutRightPart && classes.leftSection}>
					{renderInputs()}

					<StyledAccordion
						expanded={expandedSection === EXPANDABLE_SECTIONS.DATES}
						onChange={handleAccordionChange(EXPANDABLE_SECTIONS.DATES)}
					>
						<StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
							<ListItem className='p-0'>
								<ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>Dates de l'offre</span>} />
							</ListItem>
						</StyledAccordionSummary>
						<AccordionDetails className='py-2 px-1'>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div style={{ display: 'flex' }}>
									<Typography variant="body2" style={{ minWidth: '220px' }}>
										Date de début le :
									</Typography>
									<Typography variant="body2">
										{formatDateTime(dateStart)}
									</Typography>
								</div>
								<div style={{ display: 'flex' }}>
									<Typography variant="body2" style={{ minWidth: '220px' }}>
										Date de fin le :
									</Typography>
									<Typography variant="body2">
										{formatDateTime(dateEnd)}
									</Typography>
								</div>
							</div>
						</AccordionDetails>
					</StyledAccordion>
					<>
						<Divider className={classes.dividerStyle} />

						<StyledAccordion
							expanded={expandedSection === 'orderTypes'}
							onChange={handleAccordionChange('orderTypes')}
						>
							<StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
								<ListItem className='p-0'>
									<ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>Mode(s) de vente</span>} />
								</ListItem>
							</StyledAccordionSummary>
							<AccordionDetails className='py-2 px-1'>
								<Grid container spacing={1} alignItems="center">
									<Grid item xs={12}>
										<Typography variant="body2">
											{effectiveOrderTypes.map((ot) => SUITABLE_ORDER_TYPES[ot] || ot).join(', ')}
										</Typography>
									</Grid>
								</Grid>
							</AccordionDetails>
						</StyledAccordion>
						<Divider className={classes.dividerStyle} />

						<StyledAccordion
							expanded={expandedSection === EXPANDABLE_SECTIONS.LIMIT}
							onChange={handleAccordionChange(EXPANDABLE_SECTIONS.LIMIT)}
						>
							<StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
								<ListItem className='p-0'>
									<ListItemText
										style={{ color: mainColor.colorBlack }}
										primary={<span className={classes.typo}>Limites d'utilisation par panier</span>}
									/>
								</ListItem>
							</StyledAccordionSummary>
							<AccordionDetails className='py-2 px-1'>
								<Grid container spacing={1} alignItems="center">
									<Grid item xs={9}>
										<Typography variant="body2">Nombre maximal d'utilisations</Typography>
									</Grid>
									<Grid item xs={3}>
										<Typography variant="body2">{config?.limit || 'Non défini'}</Typography>
									</Grid>
								</Grid>
							</AccordionDetails>
						</StyledAccordion>
					</>

				</div>

				{!withoutRightPart && (
					<div className={classes.rightDetailSection}>
						<ListItem className='p-0' style={{ marginTop: '7px' }}>
							<ListItemText
								style={{ color: mainColor.colorBlack }}
								primary={<span className={classes.typo}>Produits concernés par l'offre</span>}
							/>
						</ListItem>


						<div className={`${classes.defaultListContainer}`}>
							{_.map(sections, section => (
								<div key={section.id}>
									<Typography variant="subtitle2" className={`${classes.sectionName} py-2`}>
										{section.name}
									</Typography>
									<Divider />
									<List disablePadding>
										{section.products.map(product => (
											<React.Fragment key={product.key}>
												<ListItem
													button
													style={{
														display: 'flex',
														justifyContent: 'space-between',
														alignItems: 'center',
														padding: 0
													}}
													className='px-3'
												>
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<ListItemText secondary={<span style={{ color: 'black' }}>{product.name}</span>} />
													</div>
													<ListItemText
														secondary={<span style={{ fontSize: '11px' }}>Prix de vente: {product.price} €</span>}
														style={{ textAlign: 'right' }}
													/>
												</ListItem>
												<Divider />
											</React.Fragment>
										))}
									</List>
								</div>
							))}
						</div>

					</div>
				)}
			</div>
		</Modal>
	);
};

export default withStyles(styles)(ProductDetailsModal);
